export default "__VITE_ASSET__574aa5d1__"